function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

function cubicBezier(P0, P1, P2, P3, t) {
  var x = (1 - t) ** 3 * P0[0] + 3 * (1 - t) ** 2 * t * P1[0] + 3 * (1 - t) * t ** 2 * P2[0] + t ** 3 * P3[0];
  var y = (1 - t) ** 3 * P0[1] + 3 * (1 - t) ** 2 * t * P1[1] + 3 * (1 - t) * t ** 2 * P2[1] + t ** 3 * P3[1];
  return [x, y];
}

// Generate cat head shape (cartoon/anime style - rounder, cuter)
export function generateCatHeadShape() {
  // All parameters are continuous random values
  var headWidth = randomFromInterval(70, 100);  // Wider for cartoon cats
  var headHeight = randomFromInterval(60, 95);
  var headCenterY = randomFromInterval(-10, 5);

  // Cat has very short, flat snout (cartoon style)
  var snoutWidth = randomFromInterval(25, 45);  // Wider snout area
  var snoutLength = randomFromInterval(5, 15);  // Very short for cartoon cats
  var snoutStartY = headCenterY + headHeight * randomFromInterval(0.4, 0.55);

  // Cheek width (cats have puffy cheeks)
  var cheekWidth = headWidth * randomFromInterval(1.1, 1.3);

  // Asymmetry factor
  var asymmetryFactor = randomFromInterval(0.9, 1.1);

  // Head roundness (cats are rounder)
  var headRoundness = randomFromInterval(0.9, 1.15);

  var results = [];

  // Left ear connection point (on top/side of head for cartoon cats)
  var leftEarX = -headWidth * randomFromInterval(0.65, 0.85);
  var leftEarY = headCenterY - headHeight * randomFromInterval(0.75, 0.95);

  // Start from left ear attachment point
  results.push([leftEarX, leftEarY]);

  // Left side going down to cheek (cats have round heads)
  var leftCheekX = -cheekWidth * randomFromInterval(0.45, 0.55) * asymmetryFactor;
  var leftCheekY = headCenterY + headHeight * randomFromInterval(0.1, 0.25);

  // From ear to cheek - round curve
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [leftEarX, leftEarY],
      [leftEarX * 1.1, headCenterY - headHeight * 0.3],
      [leftCheekX * 1.15, headCenterY - headHeight * 0.05],
      [leftCheekX, leftCheekY],
      t
    );
    results.push(point);
  }

  // Left cheek going down to snout
  var leftSnoutX = -snoutWidth / 2;
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [leftCheekX, leftCheekY],
      [leftCheekX * 0.9, snoutStartY * 0.6],
      [-snoutWidth * 0.8, snoutStartY * 0.85],
      [leftSnoutX, snoutStartY],
      t
    );
    results.push(point);
  }

  // Left side of snout (very short and flat for cartoon cats)
  var snoutBottomY = snoutStartY + snoutLength;
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [leftSnoutX, snoutStartY],
      [-snoutWidth * 0.65, snoutStartY + snoutLength * 0.5],
      [-snoutWidth * 0.45, snoutStartY + snoutLength * 0.85],
      [-snoutWidth * 0.3, snoutBottomY],
      t
    );
    results.push(point);
  }

  // Bottom of snout (very flat, almost straight for cartoon cats)
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [-snoutWidth * 0.3, snoutBottomY],
      [-snoutWidth * 0.1, snoutBottomY + 2],
      [snoutWidth * 0.1, snoutBottomY + 2],
      [snoutWidth * 0.3, snoutBottomY],
      t
    );
    results.push(point);
  }

  // Right side of snout going up
  var rightSnoutX = snoutWidth / 2;
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [snoutWidth * 0.3, snoutBottomY],
      [snoutWidth * 0.45, snoutStartY + snoutLength * 0.85],
      [snoutWidth * 0.65, snoutStartY + snoutLength * 0.5],
      [rightSnoutX, snoutStartY],
      t
    );
    results.push(point);
  }

  // Right cheek going up to ear
  var rightCheekX = cheekWidth * randomFromInterval(0.45, 0.55) / asymmetryFactor;
  var rightCheekY = headCenterY + headHeight * randomFromInterval(0.1, 0.25);

  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [rightSnoutX, snoutStartY],
      [snoutWidth * 0.8, snoutStartY * 0.85],
      [rightCheekX * 0.9, snoutStartY * 0.6],
      [rightCheekX, rightCheekY],
      t
    );
    results.push(point);
  }

  // Right ear connection point
  var rightEarX = headWidth * randomFromInterval(0.65, 0.85) / asymmetryFactor;
  var rightEarY = headCenterY - headHeight * randomFromInterval(0.75, 0.95);

  // From cheek to ear
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [rightCheekX, rightCheekY],
      [rightCheekX * 1.15, headCenterY - headHeight * 0.05],
      [rightEarX * 1.1, headCenterY - headHeight * 0.3],
      [rightEarX, rightEarY],
      t
    );
    results.push(point);
  }

  // Top of head - round arc between ears (very round for cartoon cats)
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [rightEarX, rightEarY],
      [headWidth * 0.3, headCenterY - headHeight * (1.0 + headRoundness * 0.2)],
      [-headWidth * 0.3, headCenterY - headHeight * (1.0 + headRoundness * 0.2)],
      [leftEarX, leftEarY],
      t
    );
    results.push(point);
  }

  // Calculate bounds
  let minX = Math.min(...results.map(p => p[0]));
  let maxX = Math.max(...results.map(p => p[0]));
  let minY = Math.min(...results.map(p => p[1]));
  let maxY = Math.max(...results.map(p => p[1]));

  let width = maxX - minX;
  let height = maxY - minY;

  return {
    head: results,
    width: width,
    height: height,
    center: [0, 0],
    snoutBottomY: snoutBottomY,
    maxY: maxY,
    leftEarPoint: [leftEarX, leftEarY],
    rightEarPoint: [rightEarX, rightEarY],
    headCenterY: headCenterY,
    headHeight: headHeight,
    snoutLength: snoutLength
  };
}
